module.exports = __webpack_public_path__ + "img/Groceries.276a85e3.svg";